import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DeleteIcon from "@mui/icons-material/Delete";
import FastForwardIcon from "@mui/icons-material/FastForward";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import HistoryIcon from "@mui/icons-material/History";
import SaveIcon from "@mui/icons-material/Save";
import {
  Button,
  IconButton,
  ToggleButton,
  Tooltip,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import format from "date-fns/format";
import * as React from "react";
import { PiPaintBrushBroad } from "react-icons/pi";
import { Colours } from "../assets/global/Theme-variable";
import GridContext from "../context/GridContext";
import EditSide from "./grid/components/EditSide";
import MainGrid from "./grid/components/MainGrid";
import OptionSelect from "./grid/components/OptionSelect";
import bottombarlayouts from "./grid/data/bottombarlayouts";

import { useBlocker, useLocation } from "react-router-dom";
import { DataGridContext } from "../context/DataGridContext";
import FunctionBarContext from "../context/FunctionBarContext";
import NewListModal from "./grid/components/NewListModal";
import SelectWithAddOption from "./grid/components/SelectWithAddOption";
import listAreas from "./grid/data/listAreas";
import { useAuth0 } from "@auth0/auth0-react";
import SettingsIcon from "@mui/icons-material/Settings";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { motion } from "framer-motion";
import { useMount } from "react-use";
import { API_ENDPOINTS } from "../API/apiConfig";
import { useAppContext } from "../appContext";
import { ArrowButton } from "../components/ArrowButton";
import RouterBreadcrumbs from "../components/Breadcrumbs";
import { CursorContextProvider } from "../components/CursorContextProvider";
import { RefreshButton } from "../components/RefreshButton";
import Spinner from "../components/Spinner/Spinner";
import { useUserState } from "../context/UserContext";
import AccessControl, { checkPermissions } from "./AccessControl";
import { getTextColour } from "./datagrids/utils";
import AdvancedSettings from "./grid/components/AdvancedSettings";
import AutoComplete from "./grid/components/AutoComplete";
import ErrorDialog from "./grid/components/ErrorDialog";
import IntegratedColourPicker from "./grid/components/IntegratedColourPicker";
import ListDeleteDialog from "./grid/components/ListDeleteDialog";
import ListVariantForm from "./grid/components/ListVariantForm";
import NewItemModal from "./grid/components/NewItemModal";
import NewPageDialog from "./grid/components/NewPageDialog";
import mainlayouts from "./grid/data/mainlayouts";
import smallFunctionListLayouts from "./grid/data/smallFunctionListLayouts";
import standardListLayouts from "./grid/data/standardListLayouts";

export default function DesignerToolbar({
  openAdvancedSettings,
  setDeleteErrorMessage,
  isSaving,
  handleListSelect,
  handleRevertChanges,
  closeDialog,
  list,
  listOptions,
  handleBulkBackground,
  handleBulkForeground,
  handleColourChange,
  handleCopyFormat,
  handleDeletePage,
  handleLayout,
  setNewPage,
  setNewVariant,
  copyStyles,
  setErrorMessage,
  handleNewPage,
  variant,
  page,
  toggleHistory,
  bulkBackground,
  bulkForeground,
  makeCurrent,
  toggleHistoryClick,
  handleNext,
  pageArr,
  handlePage,
  handleSubmitLayout,
  setModalVisible,
  handleVariantSelect,
  handleNewVariant,
  openDropDown,
  setOpenDropdown,
  variantOptions,
  newVariant,
  handlePageUp,
  index,
  listHistory,
  newPage,
  data,
  handlePrev,
  contextName,
  handleListSelect2,
  handleVariantSelect2,
  setList,
  setVariant,
  setPageArr,
  setPage,

  setNewChanges,
}) {
  const userPermission = useUserState();
  console.log(variantOptions);
  const revert = () =>
    handleRevertChanges(
      " ",
      null,
      data,
      contextName,
      variant,
      handleListSelect2,
      handleVariantSelect2,
      setList,
      setVariant,
      setPageArr,
      setPage,
      closeDialog,
      setNewChanges
    );
  return (
    <>
      <Box
        sx={{
          width: "100%",
          mb: 2,
          mt: 2,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <RouterBreadcrumbs />
        <Box
          sx={{
            width: "50%",
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "flex-end",
            alignItems: "center",
            // pb: 0.5,
            // pt: 0.5,

            // flex: 1,
          }}
        >
          <Tooltip title={"Advanced Settings"}>
            <>
              <ArrowButton
                onClick={() => openAdvancedSettings(true)}
                colour={Colours.gsblue}
                icon={
                  <SettingsIcon
                    sx={{
                      fontSize: 25,
                      color: Colours.gsblue,
                    }}
                    className="advanced"
                  />
                }
              />
            </>
          </Tooltip>
          <AccessControl
            userPermissions={userPermission}
            unallowedPermissions={{
              page: "screens",
              // allow: false,
              strict: false,

              action: "edit",
            }}
            renderNoAccess={() => <></>}
          >
            <Tooltip title={"Delete List"}>
              <>
                <ArrowButton
                  onClick={() =>
                    setDeleteErrorMessage({
                      open: true,
                      text:
                        variant?.list_variant === 0
                          ? `Are you sure you want to delete this screen?`
                          : `Are you sure you want to delete this variant?`,
                      button2text: "Delete",
                      // button2func: ()=>handleDeleteList,
                      button1text: "Cancel",
                      button1func: closeDialog,
                    })
                  }
                  colour={Colours.gsblue}
                  icon={
                    <DeleteIcon
                      sx={{
                        fontSize: 25,
                        color: Colours.gsblue,
                      }}
                      className="deleteVariant"
                    />
                  }
                />
              </>
            </Tooltip>
          </AccessControl>
          <AccessControl
            userPermissions={userPermission}
            unallowedPermissions={{
              page: "screens",
              strict: false,
              action: "edit",
            }}
            renderNoAccess={() => <></>}
          >
            <Box sx={{ height: "100%" }}>
              <Tooltip title={"Revert to original"}>
                <>
                  <RefreshButton
                    onClick={() =>
                      setErrorMessage({
                        open: true,
                        text: `Are you sure you want to undo all changes to list ${list.list_number} -  ${list.list_name}?`,
                        button2text: "Undo",
                        button2func: revert,
                        button1text: "Cancel",
                        button1func: closeDialog,
                      })
                    }
                  />
                </>
              </Tooltip>
            </Box>

            <LoadingButton
              onClick={() => handleSubmitLayout("submit")}
              loading={isSaving}
              variant={!isSaving ? "gradient" : "outlined"}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              disabled={isSaving}
              sx={{ height: "100%", width: 100 }}
              className="saveList"
            >
              <span>Save</span>
            </LoadingButton>
          </AccessControl>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          flex: 1,
          mb: 2,
          mt: 2,
          gap: 5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
          }}
        >
          <AutoComplete
            options={listOptions}
            value={list}
            label={"List"}
            onChange={handleListSelect}
            type={"List"}
            data={data}
            className="listSelect"
            width={200}
            toggleOpen={() => setModalVisible(true)}
          />
          <OptionSelect
            options={variantOptions.sort(
              (a, b) => a.list_variant - b.list_variant
            )}
            value={variantOptions?.find(
              (v) => v?.list_variant === variant?.list_variant
            )}
            label={"Variants"}
            onChange={handleVariantSelect}
            type="variant"
            width={140}
            addButton
            onClickAddButton={handleNewVariant}
            open={openDropDown}
            setOpen={setOpenDropdown}
          />
          <OptionSelect
            options={
              variant?.list_details?.location === "L"
                ? standardListLayouts
                : variant?.list_details?.location === "F"
                ? smallFunctionListLayouts
                : variant?.list_details?.location === "F3"
                ? bottombarlayouts
                : mainlayouts
            }
            value={
              variant?.list_details?.location === "L"
                ? standardListLayouts.find(
                    (layout) =>
                      layout.row === variant?.list_details?.rows &&
                      layout.col === variant?.list_details?.cols
                  )
                : variant?.list_details?.location === "F"
                ? smallFunctionListLayouts.find(
                    (layout) =>
                      layout.row === variant?.list_details?.rows &&
                      layout.col === variant?.list_details?.cols
                  )
                : variant?.list_details?.location === "F3"
                ? bottombarlayouts.find(
                    (layout) =>
                      layout.row === variant?.list_details?.rows &&
                      layout.col === variant?.list_details?.cols
                  )
                : mainlayouts.find(
                    (layout) =>
                      layout.row === variant?.list_details?.rows &&
                      layout.col === variant?.list_details?.cols
                  )
            }
            type="layout"
            label={"Layout"}
            onChange={handleLayout}
            width={80}
            disabled={
              !checkPermissions(userPermission, {
                page: "screens",
                action: "edit",
              })
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className="pages"
          >
            <SelectWithAddOption
              value={pageArr.find((p) => p === page)}
              onChange={handleNewPage}
              options={pageArr}
              newVariant={newVariant}
              setNewVariant={setNewVariant}
              open={newPage}
              setOpen={setNewPage}
              list={list}
              marginRight={1}
              label={"Page"}
              disabledAdd={
                !checkPermissions(userPermission, {
                  page: "screens",
                  action: "edit",
                })
              }
            />
            <AccessControl
              userPermissions={userPermission}
              unallowedPermissions={{
                page: "screens",
                action: "edit",
                strict: false,
              }}
              renderNoAccess={() => <></>}
            >
              <Tooltip
                title={
                  page !== 1 ? "Move Page Up" : "Cannot Move First Page Up"
                }
              >
                <>
                  <ArrowButton
                    disabled={page === 1}
                    onClick={() => handlePageUp("up")}
                    colour={page !== 1 ? Colours.gsblue : Colours.lightGrey}
                    icon={
                      <ArrowUpwardIcon
                        sx={{
                          fontSize: 25,
                          color:
                            page !== 1 ? Colours.gsblue : Colours.lightGrey,
                        }}
                      />
                    }
                  />
                </>
              </Tooltip>
              <Tooltip
                title={
                  page !== pageArr?.length
                    ? "Move Page Down"
                    : "Cannot move last page down"
                }
              >
                <>
                  <ArrowButton
                    colour={
                      page !== pageArr?.length
                        ? Colours.gsblue
                        : Colours.lightGrey
                    }
                    disabled={page === pageArr?.length}
                    onClick={() => handlePageUp("down")}
                    icon={
                      <ArrowDownwardIcon
                        sx={{
                          fontSize: 25,
                          color:
                            page !== pageArr?.length
                              ? Colours.gsblue
                              : Colours.lightGrey,
                        }}
                      />
                    }
                  />
                </>
              </Tooltip>

              <Tooltip
                title={
                  page !== 1
                    ? "Delete Current Page"
                    : "Cannot delete first page"
                }
              >
                <>
                  <ArrowButton
                    disabled={page === 1}
                    onClick={handleDeletePage}
                    colour={page !== 1 ? Colours.gsblue : Colours.lightGrey}
                    icon={
                      <DeleteIcon
                        sx={{
                          fontSize: 25,
                          color:
                            page !== 1 ? Colours.gsblue : Colours.lightGrey,
                        }}
                      />
                    }
                  />
                </>
              </Tooltip>
            </AccessControl>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              height: "100%",
              pb: 0.5,
              pt: 0.5,
            }}
          >
            <AccessControl
              userPermissions={userPermission}
              unallowedPermissions={{
                page: "screens",
                action: "edit",
                strict: false,
              }}
              renderNoAccess={() => <></>}
            >
              <motion.div
                style={{
                  border: "1px solid #c4c4c4",
                  // p: 1,
                  zIndex: 10,
                  borderRadius: "5px",
                  display: "flex",
                  flexDirection: "row",
                  width: copyStyles ? "max-content" : "min-content",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
                layout
                transition={{
                  opacity: { ease: "linear" },
                  layout: { duration: 0.3 },
                }}
              >
                {copyStyles === true && (
                  <motion.div
                    data-isopen={copyStyles}
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -20, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      height: "100%",
                    }}
                    layout
                  >
                    <IntegratedColourPicker
                      selectedColour={bulkBackground?.colour}
                      handleColourChange={handleBulkBackground}
                      type="bulk-bg"
                      label="Colour"
                    />
                    <IntegratedColourPicker
                      selectedColour={bulkForeground?.colour}
                      handleColourChange={handleBulkForeground}
                      type="bulk-f"
                      label="Colour"
                    />
                  </motion.div>
                )}
                <motion.div layout>
                  <ToggleButton
                    size="small"
                    value={copyStyles}
                    selected={copyStyles}
                    onClick={handleCopyFormat}
                    aria-label="bold"
                    sx={{
                      border: "none",
                      margin: 0.1,
                      background: "none",
                    }}
                    disabled={
                      !checkPermissions(userPermission, {
                        page: "screens",
                        action: "edit",
                      })
                    }
                  >
                    <PiPaintBrushBroad
                      color={Colours.gsblue}
                      size={25}
                      className="copyPaste"
                    />
                  </ToggleButton>
                </motion.div>
              </motion.div>
            </AccessControl>
          </Box>
          <Box
            sx={{
              height: "100%",
              pb: 0.5,
              pt: 0.5,
            }}
          >
            <motion.div
              style={{
                border: "1px solid #c4c4c4",
                // p: 1,
                zIndex: 10,
                borderRadius: "5px",
                display: "flex",
                flexDirection: "row",
                width: toggleHistory ? "max-content" : "min-content",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
              layout
              transition={{
                opacity: { ease: "linear" },
                layout: { duration: 0.3 },
              }}
            >
              {toggleHistory === true && (
                <motion.div
                  data-isopen={toggleHistory}
                  initial={{ x: 0, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: 0, opacity: 0 }}
                  transition={{ duration: 1 }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    height: "100%",
                  }}
                  layout
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      width: "100%",
                      pr: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifySelf: "space-between",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <IconButton
                          aria-label="rewind"
                          onClick={handlePrev}
                          disabled={index === 0}
                        >
                          <FastRewindIcon
                            sx={{
                              fontSize: 20,
                            }}
                          />
                        </IconButton>
                      </Box>
                      <Typography sx={{ width: 170, textAlign: "center" }}>
                        {variant?.list_auditTime &&
                        variant?.list_auditTime !== null
                          ? format(variant?.list_auditTime, "h:mma do MMM yy")
                          : "Unknown"}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <IconButton
                          aria-label="fast forward"
                          onClick={handleNext}
                          disabled={index >= listHistory.length - 1}
                        >
                          <FastForwardIcon
                            sx={{
                              fontSize: 20,
                            }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                    <AccessControl
                      userPermissions={userPermission}
                      unallowedPermissions={{
                        page: "screens",
                        strict: false,
                        action: "edit",
                      }}
                      renderNoAccess={() => <></>}
                    >
                      <Button
                        variant="contained"
                        aria-label="fast forward"
                        onClick={makeCurrent}
                        size="small"
                        disabled={
                          variant?.list_isCurrent === 1 ||
                          !checkPermissions(userPermission, {
                            page: "screens",
                            allow: false,
                            action: "edit",
                          })
                        }
                      >
                        Make Current
                      </Button>
                    </AccessControl>
                  </Box>
                </motion.div>
              )}
              {/* {listHistory.length > 1 && ( */}
              <motion.div
                layout
                // initial={{ x: 0, y: 0, opacity: 0 }}
                // animate={{ x: 100 }}
                // initial={false}
                // exit={{ x: 0, y: 0, opacity: 0 }}
                // transition={{ duration: 0.5 }}
              >
                <Tooltip title={"Version History"}>
                  <ToggleButton
                    size="small"
                    value={toggleHistory}
                    selected={toggleHistory}
                    onClick={toggleHistoryClick}
                    // disabled={listHistory?.length < 2}
                    aria-label="bold"
                    sx={{
                      border: "none",
                      margin: 0.1,
                      background: "none",
                    }}
                    // layout
                  >
                    {/* <motion.div layout> */}
                    <HistoryIcon
                      color={Colours.gsblue}
                      size={25}
                      className="copyPaste"
                    />
                  </ToggleButton>
                </Tooltip>
              </motion.div>
              {/* )} */}
            </motion.div>
          </Box>
        </Box>
      </Box>
    </>
  );
}
